import React from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { dateIt } from "@/lib/format";
import { BellRing, Mail } from "lucide-react";
import { toast } from "sonner";

export function NotificheContratti() {
  const { data = [] } = useQuery({
    queryKey: ["notifiche-contratti"],
    queryFn: async () => (await api.get("/notifiche/contratti")).data,
    refetchInterval: 5 * 60 * 1000,
  });
  const mailMut = useMutation({
    mutationFn: async () => (await api.post("/notifiche/contratti/invia-email")).data,
    onSuccess: (r) => (r.inviata ? toast.success(`Email ${r.esito}`) : toast.error(`Email non inviata: ${r.esito || r.motivo}`)),
    onError: (e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)),
  });
  if (data.length === 0) return null;
  return (
    <div className="mb-5 bg-red-50 border border-red-200 rounded-xl px-4 py-3 flex flex-wrap items-center gap-3" data-testid="notifica-contratti">
      <BellRing className="h-5 w-5 text-red-600 shrink-0" />
      <div className="text-sm text-red-800 font-medium">Contratti in scadenza:</div>
      {data.map((n) => (
        <Link key={n.dipendente_id} to="/anagrafica" className="text-sm bg-white border border-red-200 rounded-lg px-3 py-1 text-red-700 hover:border-red-400" data-testid={`notifica-contratto-${n.codice}`}>
          <b>{n.nome}</b> — scade il {dateIt(n.data_scadenza_contratto)}{" "}
          <span className="text-xs">({n.giorni < 0 ? `scaduto da ${-n.giorni} g` : n.giorni === 0 ? "oggi" : `tra ${n.giorni} g`})</span>
        </Link>
      ))}
      <button
        onClick={() => mailMut.mutate()}
        disabled={mailMut.isPending}
        className="ml-auto text-xs text-red-700 hover:text-red-900 inline-flex items-center gap-1 underline-offset-2 hover:underline"
        title="Il promemoria viene inviato automaticamente ogni giorno alle 8:00"
        data-testid="notifica-contratti-email-button"
      >
        <Mail className="h-3.5 w-3.5" /> {mailMut.isPending ? "Invio…" : "Invia email ora"}
      </button>
    </div>
  );
}
